<template>
    <div>
        
    </div>
</template>

<script>
import axios from 'axios';
import TimeMe from 'timeme.js';

    export default {
        mounted() {
            this.trackView();
            this.trackTime();
        },
        beforeDestroy(){
            this.sendTrackedTime();
        },
        props: [
            'id',
            'contact',
            'source'
        ],        
        data: function(){
          return {
            deckId: this.id,
            contactId: this.contact,
            viewSource: this.source,
            timerLastSent: 0,
          }
        },
        methods: {
            trackView: function(){
              if(this.contactId == ''){this.contactId = 0;}
              const url = `/deck/track/`+ this.deckId +`/`+this.contactId +`/`+this.viewSource;

              var vm = this;

              axios.get(url).then(response => {

              }).catch(() => console.warn('Oh. Something went wrong. trackView'));

          },
          trackTime: function(){
            TimeMe.initialize({
              currentPageName: "deck",
              idleTimeoutInSeconds: 30,
            });
            var vm = this;
            setTimeout(function (){
              vm.sendTrackedTime();
            }, 1000);

          },
          sendTrackedTime: function(){
            var vm = this;
            var timeToSend = TimeMe.getTimeOnCurrentPageInSeconds() - this.timerLastSent;
            
            const url = `/deck/track-time/`+ this.deckId +`/`+ timeToSend;

            axios.get(url).then(response => {

              vm.timerLastSent = TimeMe.getTimeOnCurrentPageInSeconds();
              setTimeout(function (){
                vm.sendTrackedTime();
              }, 1000);

            }).catch(() => {
              console.warn('Oh. Something went wrong. sendTrackedTime');
              setTimeout(function (){
                vm.sendTrackedTime();
              }, 1000);
            });



          }
        }

    }


</script>
